// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import AffectedPin from '@deere/cps-it.warranty-model-factory/lib/affected-pin';
import {Link} from 'react-router';
import PipAffectedPinDetails from './pip-affected-pin-details';
import PipDaysToExpiryWidget from '../../shared/components/pip-days-to-expiry-widget';
import ProductImage from './../../../shared/components/product-image';

const PipAffectedPinsListItem = props =>
    <li className='affected-pin-info-panel'>
        <div className='product-image-container'>
            <ProductImage
                baseCode={props.pin.baseMachineCode}
                placeHolderText={props.pin.baseMachineCode}
            />
        </div>
        <div className='pin-information-container'>
            <header>
                <Link to={`/products/${props.pin.pin}`}>{props.pin.pin}</Link>
                <div className='status-group'>
                    <PipDaysToExpiryWidget
                        daysLeft={props.daysLeft}
                        metric={props.metric}
                        pipCompletionStatus={props.pin.pipCompletionStatus.key}
                        showIndicatorOnly={true}
                    />
                    <div className='pip-completion-status'>{props.pin.pipCompletionStatus.value}</div>
                </div>
            </header>
            <PipAffectedPinDetails
                actions={props.actions}
                pin={props.pin}
                pipId={props.pipId}
            />
        </div>
    </li>;

PipAffectedPinsListItem.displayName = 'PipAffectedPinsListItem';
PipAffectedPinsListItem.propTypes = {
    actions: PropTypes.object.isRequired,
    daysLeft: PropTypes.number.isRequired,
    metric: PropTypes.string.isRequired,
    pin: PropTypes.instanceOf(AffectedPin).isRequired,
    pipId: PropTypes.string.isRequired
};

export default PipAffectedPinsListItem;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-affected-pins-list-item.js